import { Component, OnInit } from '@angular/core';
import { Globals } from './globals';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit{
  globalPreviewMode: boolean = true;

  constructor(private globals: Globals){
  }

  ngOnInit() {
    this.globalPreviewMode = this.globals.previeModeStatus();
    console.log('GlobalPreviewMode', this.globalPreviewMode);
  }

}
